import { withRouter } from 'react-router-dom';

const Logout = (props) => {
  
  localStorage.clear()
  window.location.replace(process.env.REACT_APP_ACCESLIBRE_URL);
  return null;
}

export default Logout;